import { render, staticRenderFns } from "./BellMusic.vue?vue&type=template&id=fec38414&scoped=true&"
import script from "./BellMusic.vue?vue&type=script&lang=js&"
export * from "./BellMusic.vue?vue&type=script&lang=js&"
import style0 from "./BellMusic.vue?vue&type=style&index=0&id=fec38414&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fec38414",
  null
  
)

export default component.exports